import { IForm } from 'core-components/classes/models/IForm'

export const calculatePhoneCodeCaption = ({ phoneCode }: IForm) =>
  phoneCode ? `+${phoneCode}` : ''
